"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MPShop
 * API documentation
 *
 * The version of the OpenAPI document: 0.0.1-alpha.58
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOfferBySearchIdRequestToJSON = exports.GetOfferBySearchIdRequestFromJSONTyped = exports.GetOfferBySearchIdRequestFromJSON = exports.instanceOfGetOfferBySearchIdRequest = void 0;
/**
 * Check if a given object implements the GetOfferBySearchIdRequest interface.
 */
function instanceOfGetOfferBySearchIdRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "searchId" in value;
    return isInstance;
}
exports.instanceOfGetOfferBySearchIdRequest = instanceOfGetOfferBySearchIdRequest;
function GetOfferBySearchIdRequestFromJSON(json) {
    return GetOfferBySearchIdRequestFromJSONTyped(json, false);
}
exports.GetOfferBySearchIdRequestFromJSON = GetOfferBySearchIdRequestFromJSON;
function GetOfferBySearchIdRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'searchId': json['searchId'],
    };
}
exports.GetOfferBySearchIdRequestFromJSONTyped = GetOfferBySearchIdRequestFromJSONTyped;
function GetOfferBySearchIdRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'searchId': value.searchId,
    };
}
exports.GetOfferBySearchIdRequestToJSON = GetOfferBySearchIdRequestToJSON;
